/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('variant:changed', function(event) {
  var productSection = event.target;

  if (!productSection || typeof productSection.querySelectorAll !== 'function') {
    return;
  }

  var priceLists = productSection.querySelectorAll('.price-list[data-price-unit="m2"]');

  Array.prototype.forEach.call(priceLists, function(priceList) {
    var prices = priceList.querySelectorAll('.price:not(.price--blackFriday)');

    Array.prototype.forEach.call(prices, function(price) {
      if (price.querySelector('.price-unit--m2')) {
        return;
      }

      var priceUnit = document.createElement('small');
      priceUnit.className = 'price-unit--m2';
      priceUnit.textContent = ' / m2 ';
      price.appendChild(priceUnit);
    });
  });
});

(function() {
  var preorderDataSelector = '[data-preorder-variants]';
  var legacyButtonSelector = '.product-form__add-button[data-action="add-to-cart"]';
  var productV2ButtonRootSelector = '#_ref_bdef73e2';

  function getLabel(name, fallback) {
    if (window.languages && window.languages[name]) {
      return window.languages[name];
    }

    return fallback;
  }

  function getVariantStatuses(dataElement) {
    if (dataElement.preorderVariantStatuses) {
      return dataElement.preorderVariantStatuses;
    }

    try {
      dataElement.preorderVariantStatuses = JSON.parse(dataElement.textContent);
    } catch (error) {
      dataElement.preorderVariantStatuses = {};
      console.error('Unable to read pre-order variant data.', error);
    }

    return dataElement.preorderVariantStatuses;
  }

  function getProductScope(dataElement) {
    return dataElement.closest('[data-section-type="product"]') ||
      dataElement.closest('.shopify-section') ||
      document;
  }

  function getVariantStatus(dataElement, variantId) {
    var statuses = getVariantStatuses(dataElement);
    return statuses[String(variantId)] || 'available';
  }

  function updateLegacyButton(dataElement, variantId) {
    var status = getVariantStatus(dataElement, variantId);

    // The theme already owns unavailable and sold-out button states.
    if (status === 'sold_out') {
      return;
    }

    var button = getProductScope(dataElement).querySelector(legacyButtonSelector);

    if (!button) {
      return;
    }

    var label = status === 'preorder'
      ? getLabel('productFormPreOrder', 'Pre-Order')
      : getLabel('productFormAddToCart', 'Add to cart');

    if (button.textContent.trim() !== label) {
      button.textContent = label;
    }
  }

  function updateProductV2Button(controller) {
    var button = controller.buttonRoot.querySelector('button');

    if (!button) {
      return;
    }

    var labelElement = button.querySelector('div');

    if (!labelElement) {
      return;
    }

    var status = getVariantStatus(controller.dataElement, controller.variantId);
    var label;

    if (status === 'sold_out') {
      label = getLabel('productFormSoldOut', 'Sold out');

      if (!button.disabled) {
        button.disabled = true;
      }

      button.setAttribute('data-preorder-sold-out', 'true');
    } else {
      label = status === 'preorder'
        ? getLabel('productFormPreOrder', 'Pre-Order')
        : getLabel('productFormAddToCart', 'Add to cart');

      if (button.getAttribute('data-preorder-sold-out') === 'true') {
        button.disabled = false;
        button.removeAttribute('data-preorder-sold-out');
      }
    }

    if (labelElement.textContent.trim() !== label) {
      labelElement.textContent = label;
    }
  }

  function initializeProductV2(dataElement) {
    if (dataElement.getAttribute('data-preorder-v2-initialized') === 'true') {
      return;
    }

    var productScope = getProductScope(dataElement);
    var buttonRoot = productScope.querySelector(productV2ButtonRootSelector);

    if (!buttonRoot) {
      return;
    }

    var statuses = getVariantStatuses(dataElement);
    var selectedVariantId = dataElement.getAttribute('data-selected-variant-id');
    var urlVariantId = new URLSearchParams(window.location.search).get('selected_variant_id');
    var firstVariantOption = productScope.querySelector('[data-variant-id]');

    if (urlVariantId && statuses[urlVariantId]) {
      selectedVariantId = urlVariantId;
    } else if (firstVariantOption && statuses[firstVariantOption.getAttribute('data-variant-id')]) {
      selectedVariantId = firstVariantOption.getAttribute('data-variant-id');
    }

    var controller = {
      buttonRoot: buttonRoot,
      dataElement: dataElement,
      variantId: selectedVariantId
    };

    productScope.addEventListener('click', function(event) {
      var variantOption = event.target.closest('[data-variant-id]');

      if (!variantOption || !productScope.contains(variantOption)) {
        return;
      }

      var variantId = variantOption.getAttribute('data-variant-id');

      if (!statuses[variantId]) {
        return;
      }

      controller.variantId = variantId;
      window.requestAnimationFrame(function() {
        updateProductV2Button(controller);
      });
    });

    var observer = new MutationObserver(function() {
      updateProductV2Button(controller);
    });

    observer.observe(buttonRoot, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      characterData: true,
      subtree: true
    });

    dataElement.setAttribute('data-preorder-v2-initialized', 'true');
    updateProductV2Button(controller);
  }

  function initializePreorderButtons() {
    var dataElements = document.querySelectorAll(preorderDataSelector);

    Array.prototype.forEach.call(dataElements, function(dataElement) {
      var selectedVariantId = dataElement.getAttribute('data-selected-variant-id');
      updateLegacyButton(dataElement, selectedVariantId);
      initializeProductV2(dataElement);
    });
  }

  document.addEventListener('variant:changed', function(event) {
    var productSection = event.target;
    var variant = event.detail && event.detail.variant;

    if (!variant || !productSection || typeof productSection.querySelectorAll !== 'function') {
      return;
    }

    var dataElements = productSection.querySelectorAll(preorderDataSelector);

    Array.prototype.forEach.call(dataElements, function(dataElement) {
      updateLegacyButton(dataElement, variant.id);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePreorderButtons);
  } else {
    initializePreorderButtons();
  }
})();

// debugger;
window.addEventListener('load', (event) => {

  try{
  var card_info = document.getElementsByClassName("card_info");
  var seeBtn = document.getElementsByClassName("seeit_action");
      if(seeBtn.length === 0){
        card_info[0].style.display = "none";
      }
  }catch(e){
  }
  try{
  // const div = document.querySelector('div');
   if(document.getElementsByClassName('sample-hidden').length === 1){  
    document.getElementsByClassName("card_info_sample")[0].style.display = "none";
   }  
  }catch(e){
  }
   
   
});


jQuery('.product-gallery__thumbnail').click(function() {
  setTimeout(function() {
    var selected_variant = jQuery('.variant-swatch .variant-swatch__item').attr('title');
    var selected_attribute = jQuery('.product-gallery__thumbnail.is-nav-selected .image--fade-in').attr('alt');
    if (selected_variant == selected_variant) {
        jQuery('.variant-swatch .variant-swatch__item[title="'+selected_attribute+'"] img').trigger('click');
    }
}, 500);
});

 $(document).ready(function() {
        var timeout;
        function getWidth() {
            var width = $(window).width();
            current = $('.header-slide.active');
            current.removeClass('active'); // Remove active class from all elements
            if (width < 991) {
              if(current.next().index() == -1 ){
                $('.header-slide:first-child').addClass('active');
              }else{
                current.next().addClass('active'); 
              }
            } 
        }
        interval = setInterval(getWidth, 3000);
        $('.header-slide').hover(
            function() {
                clearInterval(interval); // Clear the interval when hovering
            },
            function() {
                interval = setInterval(getWidth, 3000); // Restart interval when mouse leaves
            }
        );
   
         $(window).resize(function() {
            clearInterval(interval); // Clear the interval to prevent multiple intervals running simultaneously
            getWidth(); // Execute getWidth immediately when window is resized
            interval = setInterval(getWidth, 3000); // Set new interval after window is resized
        });
    });
